import styled, { css } from 'styled-components';

// Import styles
import { customMinResponsive, size, flex } from 'components/styles';

const labelTransformBaseStyle = css`
	transform: translate(0, -2.9rem) scale(0.8);
	padding: 0 0.8rem;
`;

export const Wrapper = styled.div`
	margin-bottom: 1.9rem;
	position: relative;
`;

export const FormError = styled.span`
	display: ${({ isErrorVisible }) => (!isErrorVisible ? 'none' : 'block')};
	visibility: ${({ isErrorVisible }) =>
		!isErrorVisible ? 'hidden' : 'visible'};
	font-size: ${({ theme }) => theme.fontSize.set('xs', -0.4)}rem;
	font-weight: ${({ theme }) => theme.font.normal};
	color: ${({ theme }) => theme.error.color};
	text-align: right;
	margin-top: 0.1rem;
	margin-left: auto;
`;

export const InputWrapper = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	&:focus-within label {
		${labelTransformBaseStyle}

		color: ${({ theme, isErrorVisible }) =>
			isErrorVisible
				? theme.error.color
				: theme.authentication.input.topLabelColor};
	}
	input:-webkit-autofill + label {
		${labelTransformBaseStyle}
	}
`;

export const Label = styled.label`
	position: absolute;
	pointer-events: none;
	top: 50%;
	transform: translate(0, -50%) scale(1);
	transform-origin: top left;
	transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
	color: ${({ theme, isErrorVisible }) =>
		isErrorVisible ? theme.error.color : theme.authentication.input.color};
	font-size: ${({ theme }) => theme.fontSize.set('xs', -0.2)}rem;
	line-height: 1;
	left: 2rem;
	z-index: 1;

	&.filled {
		${labelTransformBaseStyle}

		color: ${({ theme, isErrorVisible }) =>
			isErrorVisible
				? theme.error.color
				: theme.authentication.input.topLabelColor};
	}

	&:focus {
		color: ${({ theme, isErrorVisible }) =>
			isErrorVisible
				? theme.error.color
				: theme.authentication.input.topLabelColor};
	}

	background-color: ${({ theme, backgroundColor }) =>
		backgroundColor
			? theme[backgroundColor]
			: theme.authentication.labelBgOnDesktop};

	${customMinResponsive(
		size.medium,
		css`
			background-color: ${({ theme, backgroundColor }) =>
				backgroundColor
					? theme[backgroundColor]
					: theme.authentication.labelBgOnDesktop};
		`
	)}
`;

export const ErrorWrapper = styled.div`
	${flex({ jc: 'flex-start' })}
`;

export const FieldInfo = styled.span`
	display: block;
	margin-top: 0.8rem;
	text-align: left;
	font-size: ${({ theme }) => theme.fontSize.set('xs', -0.2)}rem;
	color: ${({ theme }) => theme.authentication.input.color};
`;
